<template lang="pug">
  .card
    .card-body
      h4.card-title.text-center Step 7
      hr
      p.card-text Lorem ipsum dolor sit amet consectetur adipisicing elit. Recusandae, necessitatibus iste facere sunt! Blanditiis consequuntur odio autem sit delectus doloribus repudiandae laborum, officiis incidunt illo quam ratione, vero iusto praesentium.
      ValidationObserver(ref="Validation" slim)
        ValidationProvider(name="agreement" rules="required" v-slot="{error}" slim)
          .custom-control.custom-checkbox
            input.custom-control-input#agreement(type="checkbox")
            label.custom-control-label(for="agreement") Lorem ipsum dolor, sit amet, consectetur adipisicing elit. Quidem asperiores voluptatum iure laborum, ducimus dolore eaque doloremque vel repellendus eius et illum repudiandae nam vero ab amet, soluta cumque fuga?
</template>

<style scoped=""></style>

<script>
  import { ref, reactive } from '@vue/composition-api'
  
  export default {
    name: 'step_7',

    setup() {
      const Validation = ref(null)

      return {
        Validation
      }
    }
  }
</script>